import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import useCabinetStore from '@/store/CabinetStore';
import { FUELUP_COMPANY_ID } from '@/config/constants';
import { ERROR_STRING } from '@/config/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'BackToAdminButton',
  props: {
  isTextShort: {
    type: Boolean,
    default: false,
  },
},
  emits: ['submit'],
  setup(__props, { emit }) {

const props = __props;



const router = useRouter();
const { company } = useCabinetStore();
const buttonText = computed(() =>
  props.isTextShort ? 'В кабинет администратора' : 'Вернуться в кабинет администратора',
);



function goBackToAdmin() {
  emit('submit');

  switch (company.value?.role) {
    case 'admin':
    case 'support':
    case 'first_line_support': {
      if (company.value.type === 'azs') {
        router.push({
          name: 'admin/azs',
          params: {
            id: FUELUP_COMPANY_ID,
            type: 'company',
            companyId: company.value.id ?? ERROR_STRING,
            contractId: company.value.contract?.id ?? '',
          },
        });
      } else {
        console.log({
          name: 'corp-client',
          params: {
            id: FUELUP_COMPANY_ID,
            type: 'company',
            companyId: company.value.id,
          },
        });

        router.push({
          name: 'corp-client',
          params: {
            id: FUELUP_COMPANY_ID,
            type: 'company',
            companyId: company.value.id,
          },
        });
      }
      break;
    }
    case 'accountant': {
      router.push({
        name: 'accountant/company',
        params: {
          id: FUELUP_COMPANY_ID,
          type: 'company',
          companyId: company.value.id,
          companyType: company.value.type,
        },
      });
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock(_component_UiButton, {
    class: "return-button",
    onClick: goBackToAdmin
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
    ]),
    _: 1
  }))
}
}

})